import clsx from 'clsx';
import { get } from 'lodash';
import Image from 'next/future/image';
import React from 'react';
import { RadioGroup } from '@headlessui/react';

import { ActionKind, useProductDispatch, useProductState } from '../store';
import { useTranslation } from 'react-i18next';
import useColors from '@/hooks/useColors';

const ColorPicker = (props: { containerClassName: string }) => {
  const { t } = useTranslation();
  const dispatch = useProductDispatch();
  const { getColorLabel } = useColors();
  const { product, color } = useProductState();

  function setColor(color: string) {
    dispatch({ type: ActionKind.SET_COLOR, payload: color });
  }

  return (
    <RadioGroup
      value={color}
      onChange={setColor}
      className={'space-y-4 ' + props.containerClassName}
    >
      <RadioGroup.Label className="flex space-x-1.5">
        <span className="text-sm text-gray-700 font-bold uppercase tracking-uyn">
          {t('P_PDP.OVERVIEW.COLOR')}
        </span>

        <span className="text-sm">{getColorLabel(color)}</span>
      </RadioGroup.Label>

      <ul className="flex space-x-1.5">
        {product.colors.map(color => (
          <RadioGroup.Option
            key={color.color_code}
            as="li"
            value={color.color_code}
            className="cursor-pointer"
          >
            {({ checked }) => (
              <button className={clsx({ 'ring-2 ring-black': checked })}>
                <img
                  alt={color.color_code}
                  src={get(color, 'images.0', '')}
                  className="w-12 h-12"
                />
                {/* <Image
                  src={get(color, 'images.0', '')}
                  alt={color.color_code}
                  height={50}
                  width={50}
                /> */}
              </button>
            )}
          </RadioGroup.Option>
        ))}
      </ul>
    </RadioGroup>
  );
};

export default ColorPicker;
